<template>
  <div>
    <v-layout justify-center wrap>
      <v-flex xs12>
        <v-card color="#434343" class="mx-auto" v-if="attendence">
          <v-layout justify-start wrap pt-5>
            <v-flex xs12 sm6 md6>
              <v-card-text>
                <v-layout justify-start wrap>
                   <v-flex xs12 sm12 md1 lg1 pl-lg-3>
                  <v-img src="./../../assets/images/tick.svg"></v-img>
                </v-flex>
                <v-flex xs12 sm12 md8 lg5 pt-1 text-center>
                  <span
                    style="
                      color: #ffba00;
                      font-family: nunitosansbold;
                      font-size: 18px;
                    "
                    >Students Attendance</span
                  >
                </v-flex>
                </v-layout>
              </v-card-text>
              <v-layout justify-start wrap pt-5>
                <v-flex xs6 sm6 md4>
                  <v-layout justify-center wrap>
                    <v-flex xs8 text-cenetr>
                      <span class="total">Total Students</span>
                    </v-flex>
                    <v-flex xs8 text-left v-if="attendence.TotalStudents">
                      <span
                        style="
                          color: white;
                          font-family: nunitosansextrabold;
                          font-size: 28px;
                        "
                        >{{ attendence.TotalStudents }}</span
                      >
                    </v-flex>
                    <v-flex xs8 text-left v-else>
                      <span
                        style="
                          color: white;
                          font-family: nunitosansextrabold;
                          font-size: 28px;
                        "
                        >0</span
                      >
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout justify-start wrap pt-5>
                <v-flex xs6 sm6 md4>
                  <v-layout justify-center wrap>
                    <v-flex xs8 text-left>
                      <span class="total">Total Boys</span>
                    </v-flex>
                    <!-- </v-layout>
                  <v-layout justify-start wrap> -->
                    <v-flex xs8 text-left v-if="attendence.boys">
                      <span
                        style="
                          color: white;
                          font-family: nunitosanssemibold;
                          font-size: 28px;
                        "
                        >{{ attendence.boys }}</span
                      >
                    </v-flex>
                    <v-flex xs8 text-left v-else>
                      <span
                        style="
                          color: white;
                          font-family: nunitosanssemibold;
                          font-size: 28px;
                        "
                        >0</span
                      >
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs6 sm6 md4>
                  <v-layout justify-center wrap>
                    <v-flex xs12>
                      <span class="total">Total Girls</span>
                    </v-flex>
                  </v-layout>
                  <v-layout justify-center wrap>
                    <v-flex xs12 v-if="attendence.girls">
                      <span
                        style="
                          color: white;
                          font-family: nunitosanssemibold;
                          font-size: 28px;
                        "
                        >{{ attendence.girls }}</span
                      >
                    </v-flex>
                    <v-flex xs12 v-else>
                      <span
                        style="
                          color: white;
                          font-family: nunitosanssemibold;
                          font-size: 28px;
                        "
                        >0</span
                      >
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 sm12 md6 px-2 pr-md-7 pt-3 pb-6>
              <v-card dark color="#474747" rounded="lg">
                <v-layout justify-center wrap>
                  <v-flex xs12 sm7 md7>
                    <v-card-text>
                      <span style="font-family: nunitosansbold; font-size: 13px"
                        >Todays School Attendance Report</span
                      ><br />
                      <span
                        style="
                          color: #ffba00;
                          font-family: nunitosansbold;
                          font-size: 13px;
                        "
                        >{{ currentMonth }}</span
                      >
                      <v-layout justify-start wrap pt-7>
                        <v-flex xs6 sm4 md6 lg5>
                          <v-layout wrap>
                            <v-flex xs8>
                              <span
                                style="
                                  color: #ffba00;
                                  font-family: nunitosansregular;
                                  font-size: 13px;
                                "
                                >Present</span
                              >
                            </v-flex>
                            <v-flex xs8 v-if="attendence.presentCount">
                              <span
                                style="
                                  font-family: nunitosanssemibold;
                                  font-size: 20px;
                                "
                                >{{ attendence.presentCount }}</span
                              >
                            </v-flex>
                            <v-flex xs8 v-else>
                              <span
                                style="
                                  font-family: nunitosanssemibold;
                                  font-size: 20px;
                                "
                                >0</span
                              >
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs6 sm4 md5 text-center>
                          <span
                            style="
                              color: #ffba00;
                              font-family: nunitosansregular;
                              font-size: 13px;
                            "
                            >Absent</span
                          ><br />
                          <span
                            v-if="attendence.absenteesCount"
                            style="
                              font-family: nunitosanssemibold;
                              font-size: 20px;
                            "
                            >{{ attendence.absenteesCount }}</span
                          >
                          <span
                            v-else
                            style="
                              font-family: nunitosanssemibold;
                              font-size: 20px;
                            "
                            >0</span
                          >
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-flex>
                  <v-flex xs12 sm4 md4 pt-8 text-center>
                    <v-progress-circular
                      :size="65"
                      :width="5"
                      :value="attendence.percent"
                      color="#FFBA00"
                    >
                      <span
                        v-if="attendence.percent"
                        style="color: #ffffff; font-size: 12px"
                        >{{ attendence.percent }}</span
                      >
                      <span v-else style="color: #ffffff; font-size: 12px"
                        >0</span
                      >
                    </v-progress-circular>
                    <v-flex text-center xs12 sm12 md12 py-2>
                      <span
                        style="
                          color: #ffba00;
                          font-family: nunitosansregular;
                          font-size: 13px;
                        "
                        >Todays Attendance Percentage</span
                      >
                    </v-flex>
                  </v-flex>
                </v-layout>
                <v-divider></v-divider>
                <v-layout justify-center wrap>
                  <v-flex xs10>
                    <v-card-text>
                      <span
                        style="
                          color: #ffffff;
                          font-family: nunitosansregular;
                          font-size: 13px;
                        "
                        >Click here for Detailed Report</span
                      >
                    </v-card-text>
                  </v-flex>
                  <v-flex xs2>
                    <router-link
                      :to="'/viewMoreAttendence'"
                      style="text-decoration: none"
                    >
                      <v-card-text>
                        <v-icon color="#FFBA00">mdi-arrow-right</v-icon>
                      </v-card-text>
                    </router-link>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout justify-center wrap pt-5>
      <v-flex xs12>
        <v-card class="mx-auto">
          <v-layout justify-start wrap pt-5>
            <v-flex xs12 sm6 md6>
              <v-card-text>
                <v-flex xs12 sm8 md6 text-center>
                  <v-layout justify-center wrap>
                    <v-flex xs2 sm2 md1 lg1 xl1>
                      <v-icon color="#6AC7D8">mdi-calendar</v-icon>
                    </v-flex>
                    <v-flex xs8 sm10 md8 lg8 xl8>
                      <span
                        style="
                          color: #6ac7d8;
                          font-family: nunitosansbold;
                          font-size: 18px;
                        "
                        >Usage Analyzer</span
                      >
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-card-text>
              <v-layout justify-start wrap pt-5>
                <v-flex xs6 sm6 md6>
                  <v-layout justify-center wrap>
                    <v-flex xs8 sm8 md8 text-cenetr>
                      <span
                        style="
                          color: #6ac7d8;
                          font-family: futurabook;
                          font-size: 13px;
                        "
                        >Todays User Count</span
                      >
                    </v-flex>
                    <v-flex xs8 sm8 md8 text-left>
                      <span
                        style="
                          color: black;
                          font-family: nunitosansextrabold;
                          font-size: 28px;
                        "
                        >{{ usage.todayCount }}</span
                      >
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 sm12 md6 pr-7 pt-3 pb-6 v-if="flag">
              <v-card outlined rounded="lg">
                <v-layout justify-start wrap>
                  <v-flex xs5 sm5 md5 text-left>
                    <v-card-text>
                      <span style="font-family: nunitosansbold; font-size: 13px"
                        >Users Usage</span
                      >
                    </v-card-text>
                  </v-flex>
                  <v-flex xs7 sm7 md7 v-if="flag">
                    <v-layout justify-center wrap>
                      <v-flex xs2>
                        <v-btn icon class="ma-2" @click="getUsage(week - 1)">
                          <v-icon>mdi-chevron-left</v-icon>
                        </v-btn>
                      </v-flex>
                      <v-flex xs8 text-center pt-3 v-if="flag">
                        <span>{{ from }} - {{ to }}</span>
                      </v-flex>
                      <v-flex xs2>
                        <v-btn icon class="ma-2" @click="getUsage(week + 1)">
                          <v-icon>mdi-chevron-right</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-layout justify-start wrap>
                    <v-flex xs12 sm12 md12 text-center>
                      <div id="chart" v-if="flag">
                        <apexchart
                          type="bar"
                          height="200"
                          :options="chartOptions"
                          :series="series"
                        ></apexchart>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
export default {
  data() {
    return {
      date: new Date().toISOString().substr(0, 10),
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      attendence: [],
      currentMonth: "",
      usage: [],
      graph: [],
      week: null,
      flg: true,
      flag: false,
      from: "",
      to: "",
      series: [
        {
          name: "",
          data: [],
        },
      ],
      chartOptions: {
        chart: {
          type: "bar",
          height: 350,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: [],
          labels: {
            style: {
              fontSize: "12px",
              fontFamily: "nunitosanslight",
            },
          },
        },
        yaxis: {
          labels: {
            style: {
              fontSize: "12px",
              fontFamily: "nunitosanssemibold",
            },
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val;
            },
          },
        },
      },
    };
  },
  beforeMount() {
    let ndate = new Date().toISOString().substr(5, 2);
    var month = new Array();
    month["01"] = "January";
    month["02"] = "February";
    month["03"] = "March";
    month["04"] = "April";
    month["05"] = "May";
    month["06"] = "June";
    month["07"] = "July";
    month["08"] = "August";
    month["09"] = "September";
    month["10"] = "October";
    month["11"] = "November";
    month["12"] = "December";
    this.currentMonth = month[ndate];
  },
  mounted() {
    this.getData();
    this.getUsage();
  },
  watch: {
    productStock: {
      handler: function () {
        this.$emit("stepper", {
          productStock: this.productStock,
        });
      },
      deep: true,
    },
  },

  methods: {
    getCurrentWeek() {
      const firstDayOfMonth = moment().clone().startOf("month");
      const firstDayOfWeek = firstDayOfMonth.clone().startOf("week");
      const offset = firstDayOfMonth.diff(firstDayOfWeek, "days");
      this.week = Math.ceil((moment(new Date()).date() + offset) / 7);
      return Math.ceil((moment(new Date()).date() + offset) / 7);
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/attendance/adminget",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          date: this.date,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.attendence = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getUsage(val) {
      // this.flg = false;
      this.appLoading = true;
      this.flag = false;
      this.usage = [];
      this.series[0].data = [];
      this.chartOptions.xaxis.categories = [];
      var currwk = this.getCurrentWeek();
      if (val) {
        currwk = val;
        this.week = val;
      }
      axios({
        method: "GET",
        url: "/usage/weekly",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          year: this.year,
          month: this.month,
          week: currwk,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.usage = response.data.data;
          this.from = this.usage.from.slice(0, 10);
          this.to = this.usage.to.slice(0, 10);
          this.graph = response.data.data.grpah;
          for (var i = 0; i < this.graph.length; i++) {
            this.chartOptions.xaxis.categories.push(this.graph[i].DayOfWeek);
            this.series[0].data.push(this.graph[i].count);
          }
          this.flag = true;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
<style>
.total {
  color: #ffba00;
  font-family: futurabook;
  font-size: 13px;
}
</style>